import { Card, TableCell, TableRow } from "@mui/material";
import { capitalCase } from "change-case";
import Scrollbar from "src/components/Scrollbar";
import DataHandlerTable from "src/components/data-handler/table";
import ParseDate from "src/components/date";
import Loop from "src/components/loop";
import PaginationButtons from "src/components/pagination";
import swiftParseDate from "src/utils/swift-parse-date";

const DataTable = ({ state, fetchData, rowStart, ...rest }) => {
  const { data, ...dataProps } = state;
  const headers = [
    "no",
    "Date",
    "User",
    "Name",
    "eMail ID",
    "Old Sponsor",
    "New Sponsor",
  ];

  return (
    <div>
      <Card sx={{ mt: 2 }}>
        <Scrollbar>
          <DataHandlerTable
            name="faq-table"
            headers={headers}
            dataProps={{ ...dataProps }}
          >
            <Loop
              list={data}
              render={(item, i) => (
                <>
                  <TableRow key={item.id}>
                    <TableCell>{rowStart + i}</TableCell>

                    <TableCell>{swiftParseDate(item?.created_at)}</TableCell>

                    <TableCell>{item.user?.username}</TableCell>
                    <TableCell>
                      {item.user?.user_profile?.first_name}{" "}
                      {item.user?.user_profile?.last_name}
                    </TableCell>

                    <TableCell>{item.user?.email}</TableCell>
                    <TableCell>{item?.old_sponsor?.username}</TableCell>
                    <TableCell>{item?.new_sponsor?.username}</TableCell>
                  </TableRow>
                </>
              )}
            />
          </DataHandlerTable>
        </Scrollbar>
      </Card>
      <PaginationButtons {...rest} />
    </div>
  );
};

export default DataTable;
